import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import cn from '../../../utils/cn';

// Icons
import { ReactComponent as ArrowLeftIcon } from '../../../assets/icons/arrow_left.svg';

import styles from './BackButton.module.scss';

function BackButton({ theme, buttonLabel }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate(-1)}
      className="d-flex a-center c-pointer p-t-10 p-b-10"
    >
      <span className={cn([styles.back_arrow, 'd-flex a-center j-center', theme ? styles[theme] : ''])}>
        <ArrowLeftIcon width={22} height={22} />
      </span>
      <span className={cn(['font-secondary m-l-15 c-primary-900', theme === 'light' ? 'fs-16 fw-500' : 'fs-20'])}>
        {buttonLabel || t('common.back')}
      </span>
    </button>
  );
}

BackButton.propTypes = {
  theme: PropTypes.oneOf(['light']),
  buttonLabel: PropTypes.string,
};

BackButton.defaultProps = {
  theme: null,
  buttonLabel: null,
};

export default BackButton;
